import { TabsProps } from '@mui/material';
import { StyledTabs } from './styled';

export interface TopTabsProps extends TabsProps {}

const TopTabs = (props: TopTabsProps) => {
  const { children, ...rest } = props;

  return (
    <StyledTabs variant="scrollable" scrollButtons="auto" {...rest}>
      {children}
    </StyledTabs>
  );
};

export default TopTabs;
